import { render, staticRenderFns } from "./studentOrder.vue?vue&type=template&id=232ecbe6&"
import script from "./studentOrder.vue?vue&type=script&lang=js&"
export * from "./studentOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports